<template>
    <BlogPaginationList
        :title="$t('newsLayersPage.heading')"
        postsTag="NEWS_LAYERS"
        routeName="news_layers"
        :limit="3"
    />
</template>

<script>
import BlogPaginationList from '@/components/blog/BlogPaginationList';

export default {
    components: {
        BlogPaginationList
    }
}
</script>
